import{classAdderBuilder as d}from"../../common/dist/classadder/classAdderBuilder.js";d({class:"mdc-deprecated-list-group__subheader",tag:"h3"});
//# sourceMappingURL=Subheader.js.map
